import React, { useEffect, useState, useRef } from 'react'
import { Input } from 'antd'
import './CommentInput.scss'

const CommentInput = ({
  rows = 4,
  label = 'Prompt',
  text,
  onChange,
  disabled = false,
  placeholder = 'Write a comment...'
}) => {
  const [value, setValue] = useState(text)
  const isUserTyping = useRef(false)
  const typingTimeout = useRef(null)

  // Only sync from props when we're not actively typing
  // This prevents the feedback loop where our onChange triggers a parent update
  // that comes back and overwrites what the user is typing
  useEffect(() => {
    if (!isUserTyping.current && text !== value) {
      setValue(text)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text])

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (typingTimeout.current) {
        clearTimeout(typingTimeout.current)
      }
    }
  }, [])

  const handleChange = e => {
    isUserTyping.current = true
    const newText = e.target.value
    setValue(newText)
    onChange && onChange(newText)
    // Clear any existing timeout
    if (typingTimeout.current) {
      clearTimeout(typingTimeout.current)
    }
    // Reset typing flag after debounce completes
    typingTimeout.current = setTimeout(() => {
      isUserTyping.current = false
      typingTimeout.current = null
    }, 600)
  }

  return (
    <div className="comment-input">
      <div className="comment-input-header">
        <label>{label}</label>
      </div>
      <Input.TextArea
        value={value}
        onChange={handleChange}
        readOnly={disabled}
        autosize={{ minRows: rows, maxRows: rows }}
        placeholder={placeholder}
      />
    </div>
  )
}

export default CommentInput
